'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  fixed: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};
var defaultProps = {
  fixed: false
};

var base = function base(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '\n    min-height: ' + (0, _reactackleCore.getValueString)(theme.reactackle.components.app.minHeight) + ';\n    font-family: ' + fontFamily + ';\n  ';
};

var fixed = function fixed(_ref2) {
  var fixed = _ref2.fixed;
  return fixed ? 'max-height: 100vh;' : '';
};

var AppStyled = exports.AppStyled = _styledComponents2.default.div.withConfig({
  displayName: 'AppStyled'
})(['display:flex;flex-direction:column;align-items:stretch;flex-grow:1;width:100%;max-width:100%;position:relative;box-sizing:border-box;', ';', ';'], base, fixed);

AppStyled.propTypes = propTypes;
AppStyled.defaultProps = defaultProps;
AppStyled.displayName = 'AppStyled';